import { useState } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import {
  Activity, BookOpen, ChevronDown, CircleDollarSign, Gauge, LayoutDashboard,
  LogOut, Menu, ShieldCheck, Sparkles, Users, X,
} from 'lucide-react';
import { usePortal } from '../state/PortalContext';
import { isDemoMode } from '../lib/supabase';
import { useAuth } from '../state/AuthContext';

const navItems = [
  { to: '/', label: 'Inicio', icon: LayoutDashboard, end: true },
  { to: '/oportunidades', label: 'Oportunidades', icon: Users },
  { to: '/conciliacao', label: 'Conciliacao', icon: CircleDollarSign },
  { to: '/academy', label: 'DLX Academy', icon: BookOpen },
  { to: '/integracoes', label: 'Integracoes', icon: Activity },
];

export function AppShell() {
  const { persona, personas, setPersonaId } = usePortal();
  const { signOut } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <div className="app-shell">
      <aside className={menuOpen ? 'sidebar sidebar--open' : 'sidebar'}>
        <div className="brand-row">
          <div className="brand-mark" aria-hidden="true"><span>D</span></div>
          <div><strong>DLX</strong><small>CONNECT</small></div>
          <button className="icon-button sidebar-close" onClick={() => setMenuOpen(false)} aria-label="Fechar menu"><X size={20} /></button>
        </div>
        <nav className="main-nav" aria-label="Navegacao principal">
          <span className="nav-label">Espaco de trabalho</span>
          {navItems.map(({ to, label, icon: Icon, end }) => (
            <NavLink key={to} to={to} end={end} onClick={() => setMenuOpen(false)} className={({ isActive }) => isActive ? 'nav-item nav-item--active' : 'nav-item'}>
              <Icon size={19} strokeWidth={1.8} /><span>{label}</span>
            </NavLink>
          ))}
          {persona.role === 'manager' && (
            <NavLink to="/gestao" onClick={() => setMenuOpen(false)} className={({ isActive }) => isActive ? 'nav-item nav-item--active' : 'nav-item'}>
              <Gauge size={19} strokeWidth={1.8} /><span>Gestao</span>
            </NavLink>
          )}
        </nav>
        <div className="sidebar-card">
          <Sparkles size={18} />
          <strong>MVP supervisionado</strong>
          <p>Dados anonimizados. Integracoes reais continuam protegidas ate validacao.</p>
          <NavLink to="/integracoes">Ver prontidao</NavLink>
        </div>
        <div className="sidebar-footer"><ShieldCheck size={16} /><span>Privacidade por funcao</span></div>
      </aside>

      <main className="main-content">
        <header className="topbar">
          <button className="icon-button mobile-menu" onClick={() => setMenuOpen(true)} aria-label="Abrir menu"><Menu size={22} /></button>
          <div className="topbar-status"><span className="status-dot" /> Operacao disponivel</div>
          <div className="profile-switcher">
            <div className="avatar">{persona.initials}</div>
            <label>
              <span className="sr-only">Perfil de demonstracao</span>
              <select value={persona.id} onChange={(event) => setPersonaId(event.target.value)} disabled={!isDemoMode}>
                {personas.map((item) => <option key={item.id} value={item.id}>{item.name} · {item.title}</option>)}
              </select>
            </label>
            <ChevronDown size={16} aria-hidden="true" />
            {isDemoMode && <span className="demo-badge">DEMO</span>}
            {!isDemoMode && <button className="icon-button signout-button" onClick={() => void signOut()} aria-label="Sair"><LogOut size={17} /></button>}
          </div>
        </header>
        <div className="page-wrap"><Outlet /></div>
      </main>
      {menuOpen && <button className="menu-scrim" onClick={() => setMenuOpen(false)} aria-label="Fechar menu" />}
    </div>
  );
}

